const AIR_CONDITIONER_REMOTE_CONFIG = {
  buttonPressDistance: 0.011,
  screen: {
    resolution: 2000,
    textSize: 140,
    onOffTextSize: 35,
    celsiusTextSize: 50,
    backgroundColor: 0x202020,
    backgroundColorFocused: 0x838383,
    textColor: '#000000',
  },
}

export { AIR_CONDITIONER_REMOTE_CONFIG };
